export const laborSettlementRouting = [
  {
    path: "/labor/laborSettlement/list",
    name: "labor-labor-settlement-list",
    meta: { title: "劳务结算记录" },
    component: () =>
      import(
        /* webpackChunkName: "labor-team-list" */ "@/views/labor/labor-settlement/list/index.vue"
      ),
  },
];
